import { get, del, postFd } from "@utils/axios";

const api = "assets";

export const getAllDataReq = (payload) => {
  return get(`${api}?page=${payload.page}&filters=${payload.filters}`)
};

export const createDataReq = (payload) => {
  return postFd(`${api}?`, payload);
};

export const updateDataReq = (payload) => {
  return postFd(`${api}/edit`, payload);
};

export const deleteDataReq = (id) => {
  return del(`${api}/${id}`);
};

export const getRelatedDataReq = () => {
  return get(`${api}/relatedData`);
}
export const getFilterReq = (payload) => {
  return get(`${api}?page=1&filters?company_id=1&fields=page=1&filters=organization_structure_fields_|company;preset_|grade;`)
}